
import Vue from "vue";
import UIFeatureMixinVue from "@/mixins/UIFeatureMixin.vue";
import axios from "axios";
import { IContactUsModel } from "@/types";
import AppPropsMixin from "@/mixins/AppPropsMixin.vue";
import store from "@/store";
import { VueConstructor } from "vue/types/umd";
import { UI_ENDPOINT } from "@/constants/EndPoints";
import AccessibilityMixin from "@/mixins/AccessibilityMixin.vue";

export default (
  Vue as VueConstructor<Vue & InstanceType<typeof UIFeatureMixinVue>>
).extend({
  name: "contactUs",
  props: {
    typeOfContact: { type: String, default: "APPLY" },
  },
  mixins: [UIFeatureMixinVue, AppPropsMixin, AccessibilityMixin],
  data() {
    return {
      countyCode: "" as string,
      showProgressBar: false,
      contactUsContent: [] as IContactUsModel[],
      callComplete: false,
    };
  },
  created() {
    if (this.filteredCounties.length === 0) {
      let url = UI_ENDPOINT.GET_FILTERED_COUNTIES;
      store.dispatch.dataModule.getFilteredCounties(url);
    }
  },
  mounted() {
    //@ts-ignore
    this.setAriaLabelledByForSelect(
      this.$refs.county_select_ref,
      "choose_county_id"
    );
  },
  computed: {
    filteredCounties() {
      return store.getters.dataModule.getFilteredCountiesInStore;
    },
  },
  methods: {
    getAgenciesByCounty(resourceCode: string) {
      this.showProgressBar = true;
      let url = UI_ENDPOINT.GET_CONTACTUS_AGENCIES_DETAILS_BY_CNTY;
      axios
        .get(url, {
          params: {
            countyCode: resourceCode,
            contactType: this.typeOfContact,
          },
        })
        .then((response) => {
          this.contactUsContent = response.data;
          this.callComplete = true;
        })
        .catch((error) => {
          store.dispatch.alertModule.showAlertMessageById(
            error.response.data.id
          );
        })
        .finally(() => {
          this.showProgressBar = false;
        });
    },
  },
});
